<template>
  <div>
    <vxe-grid
      ref="itemTable"
      auto-resize
      highlight-hover-row
      size="mini"
      :loading="loading"
      :data="tableData"
      :columns="tableColumns"
      :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
      :height="tableHeight > 333 ? tableHeight - 15 : 333"
      border
      :edit-rules="validRules"
    >
      <template v-slot:top>
        <div class="side-frame-success">
          <span class="side-frame-text">
            {{ $l('form_label_subscribe_to_events') || '订阅事件' }}
          </span>
          <el-divider direction="vertical" v-if="!disabled"></el-divider>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-success"
            @click="addNewsRow()"
            v-if="!disabled"
            ><i class="el-icon-plus" />{{ $l('INDEX.btn_add') || '新增' }}
          </b-button>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-success"
            @click="save()"
            v-if="!disabled"
          >
            <i class="el-icon-folder-checked  " />
            {{ $l('INDEX.btn_save') || '保存' }}
          </b-button>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_delete') || '删除'"
            placement="top"
            v-if="!disabled"
          >
            <i class="el-icon-delete tool-btn" @click="delRow(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:required="{ row }">
        <el-checkbox
          @change="(e) => requiredChange({ row, value: e })"
          size="mini"
        >
          {{ $l('INDEX.yes_no') || '是/否' }}
        </el-checkbox>
      </template>
      <template v-slot:requiredShow="{ row }">
        <el-checkbox
          :disabled="disabled"
          :checked="row.required === 1 ? true : false"
          size="mini"
        >
          {{ $l('INDEX.yes_no') || '是/否' }}
        </el-checkbox>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import TableAutoHeight from '@/mixins/table-auto-height'
// import { cron } from 'vue-cron'
export default {
  mixins: [TableAutoHeight],
  components: {
    // cron
  },
  props: {
    disabled: { type: Boolean, default: false },
    platformCode: { type: String, default: '' },
  },
  data() {
    return {
      tableData: [],
      loading: false,
      tableColumns: tableColumns(this),
      validRules: {
        eventId: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
        ],
        eventName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
        ],
      },
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      if (!this.platformCode) return
      this.$api
        .ecomOrderPlatformSubsEventListApi({
          platformCode: this.platformCode,
        })
        .then((res) => {
          this.tableData = res.body.data
        })
    },
    async addNewsRow() {
      const $itemTable = this.$refs.itemTable
      const { row: newRow } = await $itemTable.insertAt({}, -1)
      await $itemTable.setActiveCell(newRow, 'eventId')
    },
    async delRow(row) {
      const confirm = await this.$confirm(
        '是否要删除该订阅事件？',
        this.$l('INDEX.label_completeDesc'),
        {
          confirmButtonText: this.$l('INDEX.product_dialog_btn_confirm'),
          cancelButtonText: this.$l('INDEX.btn_cancel'),
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (row.subsEventCode) {
        this.loading = true
        const res = await this.$api
          .ecomOrderPlatformSubsEventDelApi({
            subsEventCode: row.subsEventCode,
          })
          .catch(() => null)
        this.loading = false
        if (!res) return
        const { status } = res
        if (status !== 200) {
          this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
          return
        }
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
          type: 'success',
        })
        this.loadData()
      } else {
        this.$refs.itemTable.remove(row)
      }
    },
    getTableData() {
      const { fullData } = this.$refs.itemTable.getTableData()
      return fullData
    },
    async validate() {
      const result = await this.$refs.itemTable.validate(true).catch(() => true)
      return !result
    },
    async save() {
      this.validate().then((val) => {
        if (!val) return

        const itemTable = this.getTableData()
        if (!itemTable || itemTable.length == 0) {
          this.$message.error(
            this.$l('tips_please_add_subscribe_to_events') || '请添加订阅事件！'
          )
          return false
        }

        this.loading = true
        this.$api
          .ecomOrderPlatformSubsEventSaveApi({
            platformCode: this.platformCode,
            itemTable: itemTable,
          })
          .then(async (res) => {
            this.loading = false
            const { status } = res
            if (status !== 200) {
              this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
              return
            }
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || '保存成功！',
              type: 'success',
            })
            this.loadData()
          })
          .catch(() => {
            this.loading = false
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
          })
      })
    },
    requiredChange({ row, value }) {
      row.required = value ? 1 : 0
    },
  },
}
</script>
